import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "280",
  "slug": "spot-south-africa-from-satellite-imagery",
  "title": "How to Recognise South Africa in Satellite Images",
  "excerpt": "South Africa contains a broad interior plateau with escarpments near parts of the eastern and southern margins.",
  "date": "2026-04-19",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/south-africa.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "South Africa contains a broad interior plateau with escarpments near parts of the eastern and southern margins. The southwest has the Cape Fold Mountains and an irregular coastline, while the drier northwest extends towards Namibia. Coastal and inland views can therefore look quite different."
    },
    {
      "type": "heading",
      "text": "The interior plateau and the Cape"
    },
    {
      "type": "paragraph",
      "text": "Compare the Cape region with the eastern escarpment. Trace mountain belts and coastlines rather than treating both as the same kind of upland."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Namibia, Botswana, and neighbouring countries share parts of the dry interior landscape. A mine or a centre-pivot field is not a country identifier. Compare relief and regional position before relying on land-use details."
    }
  ],
  "imageAlt": "South Africa regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
